import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EventService, TaskService } from '../../../../services';
import { JobScreenReleaseCodeTask } from '../../../../interfaces/screen-specific/job-screen';

@Component({
  selector: 'job-screen-release-code',
  templateUrl: './job-screen-release-code.component.html',
  styleUrls: ['./job-screen-release-code.component.scss', '../../common/job-screen-common.scss'],
})
export class JobScreenReleaseCodeComponent implements OnInit {
  @Input('jobId') jobId!: number;
  @Input('orderId') orderId!: number;
  @Input('releaseCodeTask') releaseCodeTask!: JobScreenReleaseCodeTask;
  @Input('organisationId') organisationId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;

  isShownReleaseCode: boolean;
  releaseCode: string = '';

  constructor(private eventService: EventService, private taskService: TaskService) {}

  ngOnInit(): void {}

  showReleaseCodeDialog() {
    this.releaseCode = this.releaseCodeTask.releaseCode;
    this.isShownReleaseCode = true;
  }

  saveReleaseCode() {
    this.isShownReleaseCode = false;
    this.taskService
      .updateReleaseCode({
        jobId: this.jobId,
        taskId: this.releaseCodeTask.id,
        releaseCode: this.releaseCode,
      })
      .then((res) => {
        if (res) {
          this.releaseCodeTask.releaseCode = this.releaseCode;
          this.eventService.JobScreenEvent.emit({
            event: 'refresh-notes',
            data: { jobId: this.jobId },
            sender: 'saveReleaseCode',
          });
        }
      });
  }
}
